/* eslint-disable camelcase */
import { axiosBaseQuery } from '../utils/rtk-query';
import { createApi } from '@reduxjs/toolkit/query/react';
import { User } from '../interfaces/user';
const Config = require('Config');

export interface FuelProgramData {
  _id?: string;
  status?: string;
  id?: string;
  hierarchy?: number;
  name: string;
  type: string;
  card_type: string;
  marketing_name: string;
  pfj_network: string;
  rts_plus_network: string;
  shops: Array<string>;
  stations: Array<string>;
}
export interface Company {
  _id?: string;
  company_name: string;
  company_id: string;
  company_email?: string;
  shop_ids?: {
    stm?: string;
    stmp?: string;
  };
  users?: User[];
  fuel_cards?: FuelProgramData[];
  fraud_prevention_active?: boolean;
}

export const companyService = createApi({
  reducerPath: 'companyService',
  baseQuery: axiosBaseQuery({ baseUrl: Config.companyServiceUrl }),
  tagTypes: [],
  endpoints: (builder) => ({
    getUserCompany: builder.query<Company, string>({
      query: (email) => ({
        url: `${email}`,
        method: 'GET',
      }),
      transformResponse: (data: Company[]) => data[0],
    }),
  }),
});

export const { useGetUserCompanyQuery } = companyService;

export default companyService;
